 

import { cn } from "../../utils/cn";
import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";

interface TableData {
  id: number;
  name: string;
  subscription: string;
  amount: string;
  paymentMethod: string;
  status: string;
  date: string;
}

export interface AnimatedTableProps {
  data: TableData[];
  columns: Column[];
  checkbox?: boolean;
  initialPage?: number;
  initialPageSize?: number;
  className?: string;
  view?: boolean;
}

const AnalysisTable = ({
  renderLeftContent,
}: {
  renderLeftContent: React.ReactNode;
}) => {
  const tableData: TableData[] = [
    {
      id: 1001,
      name: "Dom Enterprise",
      subscription: "Subscription",
      amount: "200,000.00",
      paymentMethod: "POS",
      status: "Completed",
      date: "March 15, 2025",
    },
    {
      id: 1002,
      name: "Peniel Travels",
      subscription: "Upgrade",
      amount: "250,000.00",
      paymentMethod: "POS",
      status: "Completed",
      date: "August 12, 2025",
    },
    {
      id: 1003,
      name: "Charly & Sons",
      subscription: "Premium",
      amount: "3,000,000.00",
      paymentMethod: "Wire transfer",
      status: "Completed",
      date: "March 15, 2025",
    },
    {
      id: 1004,
      name: "Peniel Travels",
      subscription: "Subscription",
      amount: "200,054.00",
      paymentMethod: "USSD",
      status: "Pending",
      date: "March 15, 2025",
    },
    {
      id: 1005,
      name: "Dom",
      subscription: "Upgrade",
      amount: "800,000.52",
      paymentMethod: "Bank transfer",
      status: "Completed",
      date: "March 15, 2025",
    },
    {
      id: 1006,
      name: "Charles Angels",
      subscription: "Upgrade",
      amount: "200,000.00",
      paymentMethod: "USSD",
      status: "Pending",
      date: "March 15, 2025",
    },
    {
      id: 1007,
      name: "Odogwu Paranran",
      subscription: "Subscription",
      amount: "105,050.00",
      paymentMethod: "Bank transfer",
      status: "Pending",
      date: "March 15, 2025",
    },
    {
      id: 1008,
      name: "NSPPD Movements",
      subscription: "Upgrade",
      amount: "340,000.00",
      paymentMethod: "Bank transfer",
      status: "Completed",
      date: "March 09, 2025",
    },
  ];
  const columns: Column[] = [
    { label: "#ID", key: "id", sortable: true },
    { label: "Name of company", key: "name", sortable: true },
    { label: "Transaction Type", key: "subscription", sortable: true },
    { label: "Amount", key: "amount", sortable: true },
    { label: "Payment Method", key: "paymentMethod", sortable: true },

    {
      label: "Status",
      key: "status",
      render: (value) => (
        <span
          className={cn(
            "px-2 py-1 rounded",
            value === "Completed"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          )}
        >
          {value}
        </span>
      ),
    },

    { label: "Date", key: "date", sortable: true },
  ];

  return (
    <div>
      <FleetrifyCustomTable
        renderLeftContent={renderLeftContent}
        data={tableData}
        columns={columns}
        checkbox={true}
      />
    </div>
  );
};

export default AnalysisTable;
